import React from 'react';
import { Form, Input, Popover, Select, Space, Switch, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import states from '../../../states';
import { useRecoilState } from 'recoil';

const exerciseFrequencyContent = (
  <span>
    Rather than choosing a single frequency for all exercises in the
    prescription, <br />
    use Exercise Level Frequency to choose a specific frequency for each
    exercise.
  </span>
);

const TemplateHeader = ({
  initialValues,
  editHeader,
  importedTemplate,
  exerciseFrequency,
  setExerciseFrequency,
}) => {
  let freq;
  let day;
  let inst;

  if (importedTemplate && importedTemplate.frequency) {
    /*eslint-disable-next-line*/
    freq = parseInt(importedTemplate.frequency);
    day = importedTemplate.perdiem
      ? importedTemplate.perdiem
      : initialValues.Perdiem;
    inst = importedTemplate.instructions;
  } else {
    /*eslint-disable-next-line*/
    freq = parseInt(initialValues.Frequency);
    day = importedTemplate.Perdiem
      ? importedTemplate.Perdiem
      : initialValues.Perdiem;
    inst = importedTemplate.Instructions;
  }

  return (
    <Form layout="vertical" className="mt-3">
      <Space direction="horizontal" className="mb-3">
        <div>
          <Typography.Paragraph>Prescription Frequency</Typography.Paragraph>
          <div className="mt-1">
            <Select
              size="large"
              value={freq}
              defaultValue={freq}
              virtual={false}
              name="frequency"
              placeholder="Enter frequency"
              onChange={value => editHeader('Frequency', value)}
              style={{ minWidth: 120 }}
              disabled={exerciseFrequency}
            >
              <Select.Option value={1}>1x</Select.Option>
              <Select.Option value={2}>2x</Select.Option>
              <Select.Option value={3}>3x</Select.Option>
              <Select.Option value={4}>4x</Select.Option>
              <Select.Option value={5}>5x</Select.Option>
              <Select.Option value={6}>6x</Select.Option>
              <Select.Option value={7}>7x</Select.Option>
              <Select.Option value={8}>8x</Select.Option>
              <Select.Option value={9}>9x</Select.Option>
              <Select.Option value={10}>10x</Select.Option>
            </Select>
            <span className="ml-2 mr-2">Every</span>
            <Select
              size="large"
              value={day}
              defaultValue={day}
              virtual={false}
              name="perdiem"
              placeholder="Enter per diem"
              onChange={value => editHeader('Perdiem', value)}
              style={{ minWidth: 120 }}
              disabled={exerciseFrequency}
            >
              <Select.Option value={'day'}>Day</Select.Option>
              <Select.Option value={'week'}>Week</Select.Option>
              <Select.Option value={'month'}>Month</Select.Option>
            </Select>
          </div>
        </div>
        <div className="ml-5">
          <Typography.Paragraph>
            Exercise-level Frequency{' '}
            <Popover
              title="Exercise-level Frequency"
              content={exerciseFrequencyContent}
            >
              <InfoCircleOutlined />
            </Popover>
          </Typography.Paragraph>
          <Switch
            checked={exerciseFrequency}
            size="large"
            checkedChildren="On"
            unCheckedChildren="Off"
            onChange={() => setExerciseFrequency(!exerciseFrequency)}
          />
        </div>
      </Space>
      <Form.Item name="instructions" label="Prescription Instructions">
        <Input.TextArea
          size="large"
          placeholder="Enter instructions"
          rows={4}
          defaultValue={inst}
          value={inst}
          showCount
          maxLength={750}
          onChange={e => editHeader('Instructions', e.target.value)}
        />
      </Form.Item>
    </Form>
  );
};

export default TemplateHeader;

// import React from 'react';
// import { Col, Row, Select, Switch, Typography } from 'antd';
// import {
//   ControlLabel,
//   FormControl,
//   FormGroup,
//   OverlayTrigger,
// } from 'react-bootstrap';
// import { popExerciseLevelFrequency } from '../../groups/group-exercises/pops';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
// const { Option } = Select;

// const delayShow = 500;
// const delayHide = 2000;

// const maxLength = max => value =>
//   value && value.length > max ? `Must be ${max} characters or less` : undefined;

// const maxLength250 = maxLength(250);

// const TemplateHeader = ({
//   initialValues,
//   editHeader,
//   importedTemplate,
//   exerciseFrequency,
//   setExerciseFrequency,
// }) => {
//   let freq;
//   let day;
//   let inst;

//   if (importedTemplate && importedTemplate.frequency) {
//     /*eslint-disable-next-line*/
//     freq = parseInt(importedTemplate.frequency);
//     day = importedTemplate.perdiem
//       ? importedTemplate.perdiem
//       : initialValues.Perdiem;
//     inst = importedTemplate.instructions;
//   } else {
//     /*eslint-disable-next-line*/
//     freq = parseInt(initialValues.Frequency);
//     day = importedTemplate.Perdiem
//       ? importedTemplate.Perdiem
//       : initialValues.Perdiem;
//     inst = importedTemplate.Instructions;
//   }

//   return (
//     <div className="prescription-details-section">
//       <Row>
//         <Col style={{ marginTop: 20, marginBottom: 20 }} md={24} span={24}>
//           <Typography.Text>
//             Prescription Frequency
//             <Select
//               virtual={false}
//               name="frequency"
//               defaultValue={freq}
//               style={{ width: 120, marginLeft: 12, marginRight: 12 }}
//               onChange={value => editHeader('Frequency', value)}
//               disabled={exerciseFrequency}
//             >
//               <Option value={1}>1x</Option>
//               <Option value={2}>2x</Option>
//               <Option value={3}>3x</Option>
//               <Option value={4}>4x</Option>
//               <Option value={5}>5x</Option>
//               <Option value={6}>6x</Option>
//               <Option value={7}>7x</Option>
//               <Option value={8}>8x</Option>
//               <Option value={9}>9x</Option>
//               <Option value={10}>10x</Option>
//             </Select>
//             Every
//             <Select
//               defaultValue={day}
//               virtual={false}
//               name="perdiem"
//               onChange={value => editHeader('Perdiem', value)}
//               style={{ width: 120, marginLeft: 12 }}
//               disabled={exerciseFrequency}
//             >
//               <option value={'day'}>Day</option>
//               <option value={'week'}>Week</option>
//               <option value={'month'}>Month</option>
//             </Select>
//           </Typography.Text>
//         </Col>
//       </Row>
//       <Row>
//         <Col md={24}>
//           <Typography.Title level={5}>
//             <Switch
//               size="default"
//               checkedChildren="On"
//               unCheckedChildren="Off"
//               defaultChecked={exerciseFrequency}
//               onChange={() => setExerciseFrequency(!exerciseFrequency)}
//               style={{ marginRight: 12 }}
//             />
//             Exercise Level Frequency
//             <OverlayTrigger
//               trigger={['hover']}
//               placement="right"
//               overlay={popExerciseLevelFrequency}
//               delayShow={delayShow}
//               delayHide={delayHide}
//             >
//               <FontAwesomeIcon style={{ marginLeft: 12 }} icon={faInfoCircle} />
//             </OverlayTrigger>
//           </Typography.Title>
//         </Col>
//       </Row>
//       <Row>
//         <Col style={{ marginTop: 20, marginBottom: 20 }} md={24}>
//           <FormGroup controlId="formControlsTextarea">
//             <ControlLabel>Routine Instructions</ControlLabel>
//             <FormControl
//               componentClass="textarea"
//               placeholder="textarea"
//               rows="4"
//               defaultValue={inst}
//               onInput={e => editHeader('Instructions', e.target.value)}
//               validate={[maxLength250]}
//             />
//           </FormGroup>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default TemplateHeader;
